/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import {
  SubjectFollowMode_Enum,
  subjectFollowMode_EnumFromJSON,
  subjectFollowMode_EnumToJSON,
} from "./subject_follow_mode";

export const protobufPackage = "subject_follower";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface SubjectFollowerSettings {
  utime: number;
  autoStartOnNewSubject: boolean;
  fixedElevation: boolean;
  followMode: SubjectFollowMode_Enum;
}

function createBaseSubjectFollowerSettings(): SubjectFollowerSettings {
  return { utime: 0, autoStartOnNewSubject: false, fixedElevation: false, followMode: 0 };
}

export const SubjectFollowerSettings = {
  encode(message: SubjectFollowerSettings, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).sint64(message.utime);
    }
    if (message.autoStartOnNewSubject === true) {
      writer.uint32(16).bool(message.autoStartOnNewSubject);
    }
    if (message.fixedElevation === true) {
      writer.uint32(24).bool(message.fixedElevation);
    }
    if (message.followMode !== 0) {
      writer.uint32(32).int32(message.followMode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SubjectFollowerSettings {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubjectFollowerSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.sint64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.autoStartOnNewSubject = reader.bool();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.fixedElevation = reader.bool();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.followMode = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubjectFollowerSettings {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      autoStartOnNewSubject: isSet(object.autoStartOnNewSubject)
        ? globalThis.Boolean(object.autoStartOnNewSubject)
        : false,
      fixedElevation: isSet(object.fixedElevation) ? globalThis.Boolean(object.fixedElevation) : false,
      followMode: isSet(object.followMode) ? subjectFollowMode_EnumFromJSON(object.followMode) : 0,
    };
  },

  toJSON(message: SubjectFollowerSettings): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.autoStartOnNewSubject === true) {
      obj.autoStartOnNewSubject = message.autoStartOnNewSubject;
    }
    if (message.fixedElevation === true) {
      obj.fixedElevation = message.fixedElevation;
    }
    if (message.followMode !== 0) {
      obj.followMode = subjectFollowMode_EnumToJSON(message.followMode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubjectFollowerSettings>, I>>(base?: I): SubjectFollowerSettings {
    return SubjectFollowerSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubjectFollowerSettings>, I>>(object: I): SubjectFollowerSettings {
    const message = createBaseSubjectFollowerSettings();
    message.utime = object.utime ?? 0;
    message.autoStartOnNewSubject = object.autoStartOnNewSubject ?? false;
    message.fixedElevation = object.fixedElevation ?? false;
    message.followMode = object.followMode ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
